import util from './util.js';
import http from './http.js';

export default () => {
  util();
  http();
};
